import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';

export class BusinessSellingOptions {
    public id: number = 0;
    public businessId: number = 0;
    public allowSale: boolean = false;
    public salesAdmissionHoursSchedule?: any;
    public readonly allowHomeDelivery: boolean = false;
    public readonly allowPickUpBuyers: boolean = false;
    public readonly allowPickUpCarriers: boolean = false;

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.Businesses;
    }

    public get permissionsIdToCheck(): number {
        return this.businessId;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): BusinessSellingOptions {
        const businessSellingOptions = new BusinessSellingOptions();

        businessSellingOptions.id = this.id;
        businessSellingOptions.businessId = this.businessId;
        businessSellingOptions.allowSale = this.allowSale;
        businessSellingOptions.salesAdmissionHoursSchedule = this.salesAdmissionHoursSchedule ? JSON.parse(JSON.stringify(this.salesAdmissionHoursSchedule)) : null;

        return businessSellingOptions;
    }
}
